import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';

import { iUMK, iSourceSchoolbook, iSchoolbook } from './typings';

export function createUMKList(sourceUMKs: Array<iUMK<iSourceSchoolbook>>): Array<iUMK<iSchoolbook>> {
    return sourceUMKs.map((umk: iUMK<iSourceSchoolbook>) => {
        return {
            ...umk,
            schoolbooks: umk.schoolbooks.map((schoolbook: iSourceSchoolbook) => {
                const cyrillicId = `${schoolbook.subject}_${schoolbook.author}_${umk.label}`.toLowerCase();

                return {
                    ...schoolbook,
                    id: cyrillicId,
                    umk: umk.label,
                };
            }),
        };
    });
}

export function mapSchoolbooksToSubject(
    umkList: Array<iUMK<iSchoolbook>>
): Record<SUBJECTS_SLUGS_TYPE, Array<iSchoolbook>> {
    const result: Record<SUBJECTS_SLUGS_TYPE, Array<iSchoolbook>> = {
        mathematics: [],
        nature: [],
        russian: [],
    };

    return umkList.reduce((res, umk) => {
        umk.schoolbooks.forEach((schoolbook) => {
            const { subject } = schoolbook;

            res[subject].push(schoolbook);
        });

        return res;
    }, result);
}

export function getUMKBySchoolbookId(schoolbooks: Array<iSchoolbook>, schoolbookId: string | null): string {
    const schoolbook = schoolbooks.find((sc) => sc.id === schoolbookId);

    return schoolbook ? schoolbook.umk || schoolbook.author : '';
}

export function filterSchoolbooks(schoolbooks: Array<iSchoolbook>, input: string | null): Array<iSchoolbook> {
    if (!input) {
        return schoolbooks;
    }

    const lowered = input.toLowerCase();

    return schoolbooks.filter((schoolbook: iSchoolbook) => {
        return schoolbook.umk.toLowerCase().includes(lowered) || schoolbook.author.toLowerCase().includes(lowered);
    });
}
